import { render, staticRenderFns } from "./CreateFlow.vue?vue&type=template&id=b21e4f26&"
import script from "./CreateFlow.vue?vue&type=script&lang=js&"
export * from "./CreateFlow.vue?vue&type=script&lang=js&"
import style0 from "./CreateFlow.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports